import { useInfiniteQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IProps {
  limit: number;
}

export const useWarehouseQuery = ({ limit }: IProps) => {
  return useInfiniteQuery({
    queryKey: ['getWarehousesSelect'],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.wms.getWarehouses({
        offset: pageParam,
        limit,
      });
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
  });
};
